import { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import EmailTopicItems from "./EmailTopicItems";
import EmailDetailsHeader from "./EmailItemDetails/EmailDetailsHeader";

import UserItemList from "./UserItemList";

const dummyEmailTopcis = [
  {
    id: 1,
    ticketNumber: "#2730776",
    unreadMessages: 13,
    title: "All Yi home came home country roads",
    lastUpdate: "13/Jul/2023",
  },
  {
    id: 2,
    ticketNumber: "#2730776",
    unreadMessages: null,
    title: "Smart detection not working",
    lastUpdate: "13/Jul/2023",
  },
  {
    id: 3,
    ticketNumber: "#2730776",
    unreadMessages: null,
    title: "Camera pairing issue",
    lastUpdate: "10/Jul/2023",
  },
  {
    id: 4,
    ticketNumber: "#2730776",
    unreadMessages: null,
    title: "Display is not working",
    lastUpdate: "10/Jul/2023",
  },
  {
    id: 5,
    ticketNumber: "#2730776",
    unreadMessages: null,
    title: "No Recording ",
    lastUpdate: "10/Jul/2023",
  },
];

const dummyUserList = [
  {
    profileUrl: "",
    firstName: "John",
    lastName: "Miller",
    email: "john_miller@gmail.com",
    emailTo: "cheyenne_01@gmail.com",
    date: "Feb 13, 07:15 PM",
  },
  {
    profileUrl: "",
    firstName: "Zain",
    lastName: "Levin",
    email: "zainlevin@gmal.com",
    emailTo: "cheyenne_01@gmail.com",
    date: "Feb 13, 07:15 PM",
  },
  {
    profileUrl: "",
    firstName: "Kianna",
    lastName: "Rosser",
    email: "kiannarosser@gmal.com",
    emailTo: "cheyenne_01@gmail.com",
    date: "Feb 13, 07:15 PM",
  },
  {
    profileUrl: "",
    firstName: "John",
    lastName: "Miller",
    email: "john_miller@gmail.com",
    emailTo: "cheyenne_01@gmail.com",
    date: "Feb 13, 07:15 PM",
  },
  {
    profileUrl: "",
    firstName: "John",
    lastName: "Miller",
    email: "john_miller@gmail.com",
    emailTo: "cheyenne_01@gmail.com",
    date: "Feb 13, 07:15 PM",
  },
  {
    profileUrl: "",
    firstName: "John",
    lastName: "Miller",
    email: "john_miller@gmail.com",
    emailTo: "cheyenne_01@gmail.com",
    date: "Feb 13, 07:15 PM",
  },
];

const EmailHistory = ({ selectedTicket, handleSelectTicket }: any) => {
  const [selectedUser, setSelectedUser] = useState([]);

  return (
    <Grid
      container
      sx={{
        height: "100vh",
      }}
    >
      <Grid xs={3}>
        {dummyEmailTopcis.map((topics) => {
          return (
            <EmailTopicItems
              topics={topics}
              selectedTicket={selectedTicket}
              handleSelectTicket={handleSelectTicket}
            />
          );
        })}
      </Grid>

      <Grid
        xs={9}
        sx={{
          borderLeft: "1px solid #E9E9E9",
        }}
      >
        <EmailDetailsHeader />
        <Box
          sx={{
            padding: "17px 31px 80px 14px",
            overflow: "auto",
            height: "100vh",
          }}
        >
          {dummyUserList.map((user) => {
            return <UserItemList user={user} />;
          })}
        </Box>
      </Grid>
    </Grid>
  );
};

export default EmailHistory;
